<template>
  <label class="block" :class="themeClasses">
    <slot></slot>
  </label>
</template>
<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    label?: string
    theme?: 'primary' | 'secondary'
  }>(),
  {
    label: '',
    theme: 'primary',
  }
)

const themeClasses = computed(() => {
  return {
    'text-sm font-medium mb-1 dark:text-dark-ink': props.theme === 'primary',
    'text-base font-semibold mb-2 dark:text-dark-ink': props.theme === 'secondary',
  }
})
</script>
